import { Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IsolatedElementsButtonProps {
  numIsolatedElements: number;
  onClearIsolated: () => void;
}

export default function IsolatedElementsButton({
  numIsolatedElements,
  onClearIsolated,
}: IsolatedElementsButtonProps) {
  const { t } = useTranslation('project');

  if (numIsolatedElements === 0) {
    return null;
  }

  return (
    <Tag size="sm" borderRadius="full" variant="toggle">
      <TagLabel>
        {t('viewer-interactions.isolated-elements', {
          numIsolatedElements,
        })}
      </TagLabel>
      <TagCloseButton
        onClick={onClearIsolated}
        aria-label={t('viewer-interactions.clear-isolated')}
      />
    </Tag>
  );
}
